// extracted by mini-css-extract-plugin
export default {"stepCard":"StepCard_stepCard__PbVkT","imageNum":"StepCard_imageNum__yxCOH","imgDiv":"StepCard_imgDiv__s+iOK","image":"StepCard_image__2hYRF"};